export class CanceldBy {
  id?: number;
  rideid?: number;
  type?: "rider" | "system";
  reason?: string;
}
